import React, { useState } from "react";
import {
  Anchor,
  Menu,
  Type,
  useMediaQuery,
} from "@ebscois/react-component-library";
import { Link } from "react-router-dom";
import { StyledIcon, StyledOverflowMenu, StyledLi } from "./_.styled";
import useScrollToElement from "../../hooks/useScrollToElement";

const createMenuItems = (
  items,
  slugTitle,
  slugType,
  isRightRail,
  scroll,
  onClickHandler = null
) => {
  if (!items || !items.length) {
    return undefined;
  }

  if (isRightRail) {
    const match = items.find((item) => {
      const splitSlug = item.slug.split("/");
      return splitSlug[1] === slugType && splitSlug[2] === slugTitle;
    });

    return match ? (
      <StyledLi key={match.title}>
        <Anchor
          data-testid="right-rail-vic-anchor"
          linkComponent={Link}
          onClick={(event) => {
            event.preventDefault();
            scroll(match.an?.toUpperCase(), true);
            typeof onClickHandler === "function" && onClickHandler();
          }}
          href={`#${match.an?.toUpperCase()}`}
        >
          {"View In Context"}
        </Anchor>
      </StyledLi>
    ) : undefined;
  }

  return items.map((item) => (
    <StyledLi key={item}>
      <Anchor
        linkComponent={Link}
        href={`${item.slug}#${item.an?.toUpperCase()}`}
      >
        {item.title}
      </Anchor>
    </StyledLi>
  ));
};

const ViewInContextMenu = ({
  associatedTopics,
  slugTitle = "",
  slugPubType = "",
  isRightRail = false,
  isMobileDevice,
  isTabletDevice,
  onClickHandler = null,
}) => {
  const { scroll } = useScrollToElement({ isMobileDevice, isTabletDevice });

  const mqMaxSm = useMediaQuery("max", "sm");
  const menuItems = createMenuItems(
    associatedTopics,
    slugTitle,
    slugPubType,
    isRightRail,
    scroll,
    onClickHandler
  );

  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {menuItems && (
        <Menu
          isOpen={isOpen}
          toggleMenu={toggleMenu}
          data-testid="view-in-context-menu"
          title="Open view in context menu"
          trigger={
            <StyledIcon
              icon={{ glyph: "more_vert", color: "gray600", size: "md" }}
            />
          }
          triggerAnchor={{
            vertical: "bottom",
            horizontal: mqMaxSm || isRightRail ? "right" : "left",
          }}
          menuAnchor={{
            vertical: "top",
            horizontal: mqMaxSm || isRightRail ? "right" : "left",
          }}
        >
          <StyledOverflowMenu>
            {!isRightRail && (
              <Type padding="sm" fontSize="sm" data-testid="menu-title">
                View In Context:
              </Type>
            )}
            <ul>{menuItems}</ul>
          </StyledOverflowMenu>
        </Menu>
      )}
    </>
  );
};

export default ViewInContextMenu;
